module.exports = __webpack_public_path__ + "img/stock0.977e5690.png";